<template>
    <div :class="$style.wrapper">
        <div :class="$style.menu">
            <div
                v-for="{status, name, num} in list"
                :key="name"
                :class="{[$style.chosen]: currId === status}"
                @click="handleClick(status)"
            >
                {{name}}
                <!--<span>{{num}}</span>-->
            </div>
            <span>　|　</span>
            <div
                v-for="item in type"
                :key="item.name"
                :class="{[$style.chosen]: curId == item.referer}"
                @click="handleClicks(item.referer)"
            >
                {{item.name}}
            </div>
        </div>
        <!--<div :class="$style.search">-->
            <!--<el-input-->
                <!--placeholder="商品名称/收货人姓名/订单号"-->
                <!--v-model="content"-->
                <!--clearable>-->
            <!--</el-input>-->
            <!--<el-button>订单搜索</el-button>-->
        <!--</div>-->
    </div>
</template>

<script>
    export default {
            props: ['list', 'currId', 'curId'],
        data () {
            return {
                content: '',
                status: 'all',
                type: [{name: '全部', referer: ''}, {name: 'PC商城', referer: 'PC'}, {name: '供应链', referer: '供应链'}, {name: '门店', referer: '门店'}, {name: 'k3导入', referer: 'k3导入'}, {name: '新增', referer: '管理员添加'}, {name: '扫码', referer: '扫码'}]
            };
        },
        methods: {
            handleClick (id) {
                if (this.currId !== id) {
                    this.$emit('update:currId', id);
                }
            },
            handleClicks (referer) {
                if (this.curId !== referer) {
                    this.$emit('update:curId', referer);
                }
            },
        },

    };
</script>

<style lang="less" module>
    @import '../../default';
    .wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 15px;
        border-bottom: 2px solid #dfe4ed;
        .menu {
            display: flex;
            font-size: 20px;
            color: #9ca2ad;
            & > div {
                margin: 0 20px;
                cursor: pointer;
                &:hover {
                    .chosen;
                }
                & > span {
                    color: #F64340;
                    font-size: 18px;
                }
            }

            .chosen {
                color: @orange;
            }
        }
        /*.search {*/
            /*display: flex;*/
            /*input {*/
                /*width: 300px;*/
                /*border-radius: 0;*/
                /*border: 1px solid #d8dde6;*/
                /*border-right: 0;*/
            /*}*/
            /*button {*/
                /*border-radius: 0;*/
            /*}*/
        /*}*/
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderList/Header.vue